export default __webpack_public_path__ + "static/media/AccountSetting.f46e1858.png";